import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { environment } from '../../../../src/environments/environment';
import { APIService } from './api.service';
import { UtilityService } from './utility.service';
import { ConsoleHomeService } from './console-home.service';


export interface APPDETAILS {
  appId: string;
  appType: string;
  appName: string;
  branchId: string;
  branchName: string;
  moduleId: string;
  microAppHierarchy: string;
  workspaceId:string;
  subType:string;
}

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  headers = {
    'authorization': 'Basic dmFoYW5hOkRlY2ltYWxAMTIz',
    'requestid': `${Date.now()}`,
    'Content-Type': 'application/json',
  }
  branchSubject = new Subject()
  appSubject: Subject<Object> = new BehaviorSubject<Object>(null);
  deleteAppSubject:Subject<Object> = new BehaviorSubject<Object>(null);
  filterAccessSUbject = new Subject<string>();
  environmentSubject: any;
  selectedEnvDetail:any;
  /**
   * Class Initializer
   * @param us;
   * @param apiService;
   */

  constructor(
    private readonly us: UtilityService,
    private readonly apiService: APIService,
    private readonly chs: ConsoleHomeService
  ) {}

  public saveCoookie(data, url) {
    const path = `${environment.cookieUrl}/navigation-server/preferences/create?domain=${url}`;

    return this.apiService.post(path, data);
  }

  setSelectedEnvDetail(env){
    this.selectedEnvDetail = env;
  }

  getSelectedEnvironmentDetail(){
    return this.selectedEnvDetail;
  }

  public saveCoookieVconnect(data, url, type) {
    let path;
    if (type === 'vconnect') {
      path = `${environment.cookieUrlVconnect}/navigation-server/preferences/create?domain=${url}`;
    } else if (type === 'Enviroment') {
      path = `${environment.cookiesUrlEnvironment}/navigation-server/preferences/create?domain=${url}`;
    } else if (type === 'release-manager') {
      path = `${environment.cookiesUrlReleaseManager}/navigation-server/preferences/create?domain=${url}`;
    } else if (type === 'vlogs') {
      path = `${environment.cookiesUrlVlogs}/navigation-server/preferences/create?domain=${url}`;
    } else if (type === 'vhub') {
      path = `${environment.cookiesUrlVhub}/navigation-server/preferences/create?domain=${url}`;
    }  else if (type == 'vMonitor') {
      path = `${environment.cookiesUrlVmonitor}/navigation-server/preferences/create?domain=${url}`;
    }   else if (type == 'vMonitorPwa') {
      path = `${environment.cookiesUrlVmonitorPwa}/navigation-server/preferences/create?domain=${url}`;
    }    else if (type == 'schedulerConfig') {
      path = `${environment.cookiesUrlVscheduler}/navigation-server/preferences/create?domain=${url}`;
    }
    else if (type == 'schedulerExecution') {
      path = `${environment.cookiesUrlVscheduler}/navigation-server/preferences/create?domain=${url}`;
    }
    return this.apiService.post(path, data);
  }

  setAppSubject(data) {
    this.appSubject.next(data);
  }

  getApplicationListApi(queryParam) {
    const path = `/application/filter?${queryParam}`;
    return this.apiService.get(`${environment.applicationUrl}${path}`,{
      headers: this.headers
    });
  }

  getTeamApi(queryParam) {
    const path = `/team/filter?${queryParam}`;
    return this.apiService.get(`${environment.resourceUrl}${path}`,{
      headers: this.headers
    });
  }


  roleListApi(queryParam?) {
    let path = `/role/filter`;
    if (queryParam) {
      path = `${path}?${queryParam}`;
    }
    return this.apiService.get(`${environment.resourceUrl}${path}`,{
      headers: this.headers
    });
  }

  getWorkspaceOwner(workspaceId){
    const body={
      hierarchyList:[workspaceId]
    }
    return this.apiService.post(`${environment.getWorkSpaceOwner}`, body, { headers: this.headers });

  }

  getDeploymentList(queryParam) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const path = `/deployment/getDeployedBranchByOrgApp?${queryParam}`;
    return this.apiService.get(`${environment.releaseUrl}${path}`, {
      headers
    });
  }

  getDeploymentHistoryDetails(body){
    return this.apiService.post(`${environment.getDeploymentHistoryDetails}`,body,{headers: this.headers});

  }

  getUserDetails(list) {
    if (list.length === 0) {
      return;
    }
    const data = {
      userList: list.map(ele => ele.memberId),
    };
    this.getBulkDetails(data).subscribe(res => {
      if (res && res['code'].toLowerCase() === 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.getAllMemberRole(list);
          this.userHandleResponse(res['data'], list);
        }
      }
    });
  }

  getAllMemberRole(list){
    if (list.length === 0) {
      return;
    }
    const data = {
      userName :"ALL",
      workspaceNames : [this.us.orgname]
    };
    this.getAllRole(data).subscribe((res:any) => {
        if (res) {
          list.forEach(ele => {
            const obj = res.find(ele1 => ele1.userId.toLowerCase() === ele.email.toLowerCase());
            if (obj) {
              ele['role'] = 'WORKSPACE ' + obj.role;
            }
          });
        }
    });
  }

  userHandleResponse(responseData, list) {
    list.forEach(ele => {
      const obj = responseData.find(ele1 => ele1.userId === ele.memberId);
      if (obj) {
        ele['name'] = obj.displayName;
        ele['icon'] = obj.imageUrl;
        ele['email'] = obj.email;
      }
    });
    return list;
  }

  getBulkDetails(data) {
    const path = `/user/bulk-detail`;
    return this.apiService.post(`${environment.url}${path}`, data,{
      headers: this.headers
    });
  }

  getAllRole(data) {
    const path = `usermanagement/user/v2/management/users-and-roles`;
    return this.apiService.post(`${environment.accountMngURL}${path}`, data,{
      headers: this.headers
    });
  }

  addUser(data) {
    const path = '/user/invite';
    return this.apiService.post(`${environment.url}${path}`, data,{
      headers: this.headers
    });
  }

  getUserById() {
    const path = `/user?userId=${this.us.getUserId()}`;
    return this.apiService.get(`${environment.url}${path}`,{
      headers: this.headers
    });
  }

  getAccountWorkspaceList(query) {
    const path = `/workspace/selection-list?${query}`;
    return this.apiService.get(`${environment.accountUrl}${path}`,{
      headers: this.headers
    });
  }

  getOrgById(query) {
    const httpOptions = {
      requestid: `${Date.now()}`,
      ['Content-Type']: 'application/json',
      Authorization: environment.paAuth,
    } as any;
    const path = `/usermanagement/user/management/org/v1/getOrgByName?${query}`;
    return this.apiService.get(`${environment.cookieUrl}${path}`, {
      headers: httpOptions,
    });
  }

  getAccountList(query) {
    const path = `/account/filter?${query}`;
    return this.apiService.get(`${environment.accountUrl}${path}`,{
      headers: this.headers
    });
  }

  acceptRejectRequest(data, workspaceId) {
    const path = `/workspace/request-action?workspaceId=${workspaceId}`;
    return this.apiService.post(`${environment.accountUrl}${path}`, data,{
      headers: this.headers
    });
  }

  getNotification(param) {
    const path = `/workspace/notifications?${param}`;
    return this.apiService.get(`${environment.accountUrl}${path}`,{
      headers: this.headers
    });
  }

  getUserExistApi(queryParam) {
    const path = `/account/user-exist`;
    return this.apiService.get(`${environment.accountUrl}${path}?${queryParam}`,{
      headers: this.headers
    });
  }

  updateVariable(body){
    const path = '/application-manager/api/v1/application/update-properties';
    return this.apiService.put(`${environment.endPoint}${path}`, body,{
      headers: this.headers
    });
  }
  //

  getDomain(app) {
    if(app==='console'){
    return environment.dynamicCookieConsoleUrl
    }
    else if(app==='dev'){
      return environment.designerDomain
    } else if(app==='home'){
      return environment.consoleDomain
    }
    else{
      return environment.dynamicCookieIamUrl
    }
    // const cookieUrl =
    //   app === 'console'
    //     ? environment.dynamicCookieConsoleUrl
    //     : environment.dynamicCookieIamUrl;
    //   return cookieUrl;
  }

  getPreference(app) {
    const path = `/navigation-server/preferences?name=ACCESS_LEVEL&domain=${this.getDomain(app)}`;
    if(app==='console'){
      return this.apiService.get(`${environment.cookieConsoleUrl}${path}`,{
        headers: this.headers
      })
    } else if(app==='home'){
      const userId = this.us.getCookie('USER_ID');
      if (userId) {
        return this.apiService.get<any>(
          environment.getPreferenceConsoleHome +
            'userId=' +
            userId +
            `&domain=${
              this.getDomain('home')
            }`,{
              headers: this.headers
            }
        );
      }
    }
    else if(app === 'dev'){
      const userId = this.us.getCookie('USER_ID');
      if (userId) {
        return this.apiService.get<any>(
          environment.getPreferenceDesigner +
            'userId=' +
            userId +
            `&domain=${
              this.getDomain(app)
            }`,{
              headers: this.headers
            }
        );
      }
      // const path = `/navigation-server/preferences?name=ACCESS_LEVEL&domain=${this.getDomain(app)}`
      // return this.apiService.get(`${environment.vDesignerCoookieUrl}${path}`)
    }
    else{
      return this.apiService.get(`${environment.cookieIamUrl}${path}`,{
        headers: this.headers
      })
    }
    // return this.apiService.get(`
    // ${app === 'console' ? environment.cookieConsoleUrl : environment.cookieIamUrl}${path}`);
  }

  /**
   * savePreference;
   * @param preferences;
   */
  public savePreference(preferences: object[], cookieUrl?, domain?) {
    const data = {
      userId: this.us.getUserId(),
      username: this.us.getUserName(),
      preferences,
    };

    let path = '/navigation-server/preferences/create';

    if (domain) {
      path = `${path}?domain=${domain}`;
    }

    return this.apiService.post(`${cookieUrl ?? environment.cookieUrl}${path}`, data,{
      headers: this.headers
    });
  }

  createCookie(data: object) {
    const path = '/navigation-server/cookies/create';
    return this.apiService.post(`${environment.cookieUrl}${path}`, data,{
      headers: this.headers
    });
  }


  getMicroAppBranchApi(queryParam) {
    const path = `/application/get-micro-app?${queryParam}`;
    return this.apiService.get(`${environment.applicationUrl}${path}`,{
      headers: this.headers
    });
  }

  /**
   * signout
   */
  signout() {
    const path = '/logout';
    return this.apiService.get(`${environment.homeUrl}${path}`,{
      headers: this.headers
    });
  }

  getSourceAppBranch(sourceAppId: string) {
    const path = `/iam-resource-manager/application/sync/environments?sourceAppId=${sourceAppId}`;
    return this.apiService.get(`${environment.endPoint}${path}`,{
      headers: this.headers
    })
  }

  saveAppDetails(app:APPDETAILS) {
    const preferences = [
      {
        name: 'APP_ID',
        value: app.appId, // important for all apis
      },
      {
        name: 'APP_TYPE',
        value: app.appType,
      },
      {
        name: 'APP_NAME',
        value: app.appName,
      },
      {
        name: 'BRANCH_ID',
        value: app.branchId
      },
      {
        name: 'BRANCH_NAME',
        value: app.branchName
      },
      // {
      //   name: 'MICROAPP_ID',
      //   value: app.moduleId
      // },
      {
        name: 'MODULE_ID',
        value: app.moduleId
      },
      {
        name: 'MICROAPP_HIERARCHY',
        value: app.microAppHierarchy
      },
      // {
      //   name: 'WORKSPACE_ID',
      //   value: app.workspaceId
      // },
      {
        name: 'APP_SUBTYPE',
        value: app.subType
      }

    ];
    return this.savePreference(preferences);
  }

  // filterAccessReq(): Observable<string> {
  //   this.chs.filterAccessReq(appId).subscribe((res) => {
  //     let filterAccessRes = res;
  //     if(filterAccessRes['data']?.length > 0) {
  //       if(filterAccessRes['data'][0].status === 'FULFILLED'){
  //         this.us.destinationOrgId = filterAccessRes['data'][0].destinationOrgId;
  //         this.us.destinationAppId = filterAccessRes['data'][0].destinationAppId;
  //         this.filterAccessSUbject.next('FULFILLED');
  //       } else {
  //         this.us.destinationOrgId = '';
  //         this.us.destinationAppId = '';
  //         this.filterAccessSUbject.next('NOT_FULFILLED');
  //         // this.us.openSnackBar('Middleware app is not connected, Please conect middleware app');
  //       }
  //     } else {
  //       this.filterAccessSUbject.next('NOT_FULFILLED');
  //       // this.us.navigateTo('/app-development/dashboard');
  //       // this.us.openSnackBar('Please connect middleware app');
  //     }
  //   });
  //   return this.filterAccessSUbject.asObservable();
  // }

  openHelpUrl(path){
    const httpOptions = {
      requestid: `${Date.now()}`,
      withCredentials: true,
    } as any;
   return this.apiService.get(`${environment.helpUrl}${path}`,{
    headers: httpOptions,
  })
  }

  generatesslTokenApi() {
    const body={
      "orgId":"JIRA_TICKET-TB79CBOFA8",
      "appId":"DEMO-S9KRC0V5FD",
      "loginId":this.us.getUserName()
     }

    const httpOptions = {
      requestid: `${Date.now()}`,
      withCredentials: true,
      orgid:'VAHANA',
      appid:'PORTAL',
      loginid: this.us.getUserName(),
      servicename: "GENERATE_SSO_TOKEN",
      clientsecret: "3f76d1bb-8bf8-4aef-b79b-1e5d9b0bd007"
    } as any;

    const endpoint = `${environment.appDomain}/gatewayProcessor`
    return this.apiService.post(`${endpoint}`,body, {
     headers: httpOptions,
   });
 }

  generateOtp(accountName,accountId,selectedApp,selectedAppId){
    const body={
      orgId:"VAHANA",
      appId:"PORTAL",
      serviceType:"LOGIN",
      appName:selectedApp,
      email:accountId,
      selectedAppId:selectedAppId,
      type:"deleteapp",
      userName:accountName,
      reference:""
    }
    return this.apiService.post(`${environment.generateOtp}`, body, { headers: this.headers   });
  }

  validateOtp(otp,reference,emailId,selectedAppId){
    const body={
      orgId:"VAHANA",
      appId:"PORTAL",
      serviceType:"LOGIN",
      emailId:emailId,
      selectedAppId:selectedAppId,
      type:"deleteapp",
      otp:otp,
      reference:reference
   }
   return this.apiService.post(`${environment.validateOtp}`, body, { headers: this.headers });

  }

  getOwnerDetails(workspaceOwnerId){
    const body={
      userList:[workspaceOwnerId]
    }
    return this.apiService.post(`${environment.getOwnerDetails}`, body, { headers: this.headers });

  }

  deleteApplicationApi(applicationId,loginId){
    const body={
      appId:applicationId,
      loginId:loginId,
      unlinkDataObject:{
        appId:applicationId,
        microAppId:this.us.getModuleId(),
        collectionReference:[]
      }
    }
    return this.apiService.post(`${environment.deleteApp}`, body, { headers: this.headers });

  }


}
